<template>
  <div id="app" class="app">
      <div class="downapp" @click="downApp"></div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      msg: "",
      cid: null
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
   
  },
   methods: {
    downApp() {
       var ua = window.navigator.userAgent.toLowerCase();
          this.$point.eventuid(
            "down_app_calc_" + this.cid,
            this.cid,
            "down_app"
          );
       window.location.href = 'http://www.haoyunba.com/web/apk/clac_android_V1.0.0_100_clac_a_gdt_1.apk' 
    }
   },

  components: {
    headBack
  }
}
</script>
<style  scoped>
.downapp{
   width: 750px;
  height: 1708px;
  background: url('../../assets/img/1068.png');
  background-size: 100% 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/downapp/downCalcgdt.vue